module.exports = __webpack_public_path__ + "img/building-red.08954077.png";